import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class GrowOnboardingGuardService {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(fromAppRoot.selectCustomerAndGrowAccount),
      map(({ customer, growAccount }) => {
        const isPro = customer.inyova_pro;

        if (!growAccount || isPro) {
          return this.router.parseUrl('/');
        }

        return true;
      })
    );
  }
}

export const GrowUserGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => inject(GrowOnboardingGuardService).canActivate();
